import { types } from 'mobx-state-tree';

const EbayData = types
  .model('EbayData', {
    currentSellerLevel: types.optional(types.string, ''),
    feedbackScore: types.optional(types.number, 0),
    feedbackTotalNegative: types.optional(types.number, 0),
    feedbackTotalNeutral: types.optional(types.number, 0),
    feedbackTotalPositive: types.optional(types.number, 0),
    monthlyCreditsNumber: types.optional(types.number, 0),
    monthlyCurrentSoldMoney: types.optional(types.number, 0),
    monthlyForecastUploadedNumber: types.optional(types.number, 0),
    monthlySellingLimitMoney: types.optional(types.number, 0),
    monthlySellingLimitNumber: types.optional(types.number, 0),
    monthlyUploadedNumber: types.optional(types.number, 0),
    negativeSellerReview: types.optional(types.number, 0),
    neutralSellerReview: types.optional(types.number, 0),
    positiveSellerReview: types.optional(types.number, 0),
    storeSubscription: types.maybe(types.string),
    casesWithoutResolutionNumber: types.optional(types.number, 0),
    positiveFeedbackPercentage: types.optional(types.number, 0),
    sellerName: types.maybe(types.string),
  })
  .views(self => ({
    get noEbayData() {
      return (
        self.currentSellerLevel === '' &&
        self.feedbackScore === 0 &&
        self.feedbackTotalNegative === 0 &&
        self.feedbackTotalNeutral === 0 &&
        self.feedbackTotalPositive === 0 &&
        self.monthlyCreditsNumber === 0 &&
        self.monthlyCurrentSoldMoney === 0 &&
        self.monthlyForecastUploadedNumber === 0 &&
        self.monthlySellingLimitMoney === 0 &&
        self.monthlySellingLimitNumber === 0 &&
        self.monthlyUploadedNumber === 0 &&
        self.negativeSellerReview === 0 &&
        self.neutralSellerReview === 0 &&
        self.positiveSellerReview === 0 &&
        !self.storeSubscription &&
        self.casesWithoutResolutionNumber === 0 &&
        self.positiveFeedbackPercentage === 0
      );
    },
    get mockedData() {
      return {
        currentSellerLevel: 'Basic',
        feedbackTotalNegative: 5,
        feedbackTotalNeutral: 7,
        feedbackTotalPositive: 45,
        monthlyCreditsNumber: 250,
        monthlyCurrentSoldMoney: 400,
        monthlyForecastUploadedNumber: 200,
        monthlySellingLimitMoney: 500,
        monthlySellingLimitNumber: 320,
        monthlyUploadedNumber: 140,
        negativeSellerReview: 2,
        neutralSellerReview: 5,
        positiveSellerReview: 17,
        positiveFeedbackPercentage: 90,
        storeSubscription: 'Above Standard',
      };
    },
  }));

export default EbayData;
